export default __webpack_public_path__ + "static/media/shopify-shop-launch.c45e8f02.png";